module.exports = require("piramis-js-utils/lib/isMobile")
